module.exports = __webpack_public_path__ + "static/media/react-gif.8b0e454f.gif";